<app-metric-card
  class="col-4 mb-2"
  role="button"
  tabindex="0"
  [title]="'Average Mean Time To Mitigate'"
  [currentValue]="averageMeanTimeToMitigateResponse().current_average_mean_time_to_mitigate ?? 0"
  [previousValue]="averageMeanTimeToMitigateResponse().previous_average_mean_time_to_mitigate ?? 0"
  [valueChange]="averageMeanTimeToMitigateResponse().mttm_days_difference ?? 0"
  [isHigherBetter]="false"
  [suffix]="' days'"
  (click)="onViewData()"
  (keydown.enter)="onViewData()"
></app-metric-card>

@if (showPopup()) {
  <kendo-dialog
    (close)="close()"
    [width]="'95vw'"
    [height]="'90vh'"
    [minWidth]="'800px'"
    [maxWidth]="'1400px'"
  >
    <kendo-dialog-titlebar>{{ modalTitle() }}</kendo-dialog-titlebar>

    @if (datatableUrl(); as url) {
      <div class="table-responsive w-100">
        <app-datatable
          [data-href]="url"
          [columns]="datatableColumns"
          [useOData]="true"
          [initialFilters]="periodParams()"
        ></app-datatable>
      </div>
    }
  </kendo-dialog>
}
